import React from 'react'

export default function Title(props) {
    return (
        <div className="product-title">
            <h1>{props.title}</h1>
        </div>
    )
}
